// JSON-LD for the `thesis` surface (`/thesis/[signature]`).
//
// Schema choice: SocialMediaPosting (a sub-type of Article specifically
// designed for short-form takes / opinion posts). Includes the author
// Person if `ctx.name` is supplied.

import type { ShareSurface } from '@/lib/share/events';

import { organizationId, websiteId } from './site';
import type { JsonLdBuilderContext, JsonLdPayload } from './types';

export function buildThesisJsonLd(
  _surface: Extract<ShareSurface, { kind: 'thesis' }>,
  ctx: JsonLdBuilderContext,
): JsonLdPayload {
  const headline = ctx.name ?? 'Thesis on Morfi';
  return [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${ctx.pageUrl}#webpage`,
      url: ctx.pageUrl,
      name: headline,
      ...(ctx.description !== undefined ? { description: ctx.description } : {}),
      primaryImageOfPage: { '@type': 'ImageObject', url: ctx.ogImageUrl },
      isPartOf: { '@id': websiteId() },
      publisher: { '@id': organizationId() },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'SocialMediaPosting',
      '@id': `${ctx.pageUrl}#post`,
      headline,
      ...(ctx.description !== undefined ? { articleBody: ctx.description } : {}),
      url: ctx.pageUrl,
      image: ctx.ogImageUrl,
      publisher: { '@id': organizationId() },
    },
  ];
}
